(function () {
  if (window.__ry) return;
  window.__ry = true;
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function all(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }

  /* ---------- Global pause for moving content (WCAG 2.2.2) ---------- */
  var paused = false;
  try { paused = sessionStorage.getItem('ry-paused') === '1'; } catch (e) {}
  function setPaused(v) {
    paused = !!v;
    window.ryPaused = paused;
    root.classList.toggle('ry-paused', paused);
    try { sessionStorage.setItem('ry-paused', paused ? '1' : '0'); } catch (e) {}
    all('[data-ry-pause]').forEach(function (b) {
      b.setAttribute('aria-pressed', paused ? 'true' : 'false');
      var l = b.querySelector('[data-ry-pause-label]');
      if (l) l.textContent = paused ? 'Play animations' : 'Pause animations';
    });
    all('video[autoplay]').forEach(function (v) { try { paused ? v.pause() : v.play(); } catch (e) {} });
    document.dispatchEvent(new CustomEvent('ry:pause', { detail: paused }));
  }
  window.ryPaused = paused;
  if (paused) root.classList.add('ry-paused');

  /* ---------- Accessible word splitting ---------- */
  function splitWords(el, cls, keepAccessible) {
    var words = [];
    var target = el;
    if (keepAccessible) {
      var sr = document.createElement('span');
      sr.className = 'ry-vh';
      sr.textContent = el.textContent.replace(/\s+/g, ' ').trim();
      var vis = document.createElement('span');
      vis.setAttribute('aria-hidden', 'true');
      while (el.firstChild) vis.appendChild(el.firstChild);
      el.appendChild(sr);
      el.appendChild(vis);
      target = vis;
    }
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span');
            w.className = cls;
            if (cls === 'ry-w') { var inner = document.createElement('span'); inner.textContent = part; w.appendChild(inner); }
            else { w.textContent = part; }
            frag.appendChild(w);
            words.push(w);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') { walk(n); }
      });
    })(target);
    return words;
  }

  var io = null;
  if (!reduce && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var t = e.target;
        t.classList.add('is-in');
        io.unobserve(t);
        if (t.hasAttribute('data-ry-count')) countUp(t);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
  }
  function watch(el) { if (io) io.observe(el); else el.classList.add('is-in'); }

  function countUp(el) {
    var raw = String(el.getAttribute('data-ry-count')).replace(/,/g, '');
    var to = parseFloat(raw);
    if (isNaN(to)) return;
    var dec = (raw.split('.')[1] || '').length, start = 0, D = 1700;
    function fmt(v) { return v.toLocaleString('en-IN', { minimumFractionDigits: dec, maximumFractionDigits: dec }); }
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / D), e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(to * e);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var heroes = [], manis = [], marquees = [];
  var hdr = null, drawer = null, drawerOpen = false;

  /* ---------- Header, mobile menu with focus trap ---------- */
  function initHeader() {
    hdr = document.querySelector('[data-ry-hdr]');
    drawer = document.getElementById('ry-drawer');
    all('[data-ry-pause]').forEach(function (b) {
      if (b.__ry) return; b.__ry = 1;
      b.addEventListener('click', function () { setPaused(!paused); });
    });
    setPaused(paused);
    if (!hdr || !drawer || hdr.__ry) return;
    hdr.__ry = 1;
    var btn = hdr.querySelector('.ry-menu-btn'), close = drawer.querySelector('.ry-drawer__close');
    var focusables = function () { return all('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])', drawer).filter(function (x) { return x.offsetParent !== null; }); };
    function open() {
      drawer.hidden = false; drawerOpen = true;
      requestAnimationFrame(function () { requestAnimationFrame(function () { drawer.classList.add('is-open'); }); });
      btn.setAttribute('aria-expanded', 'true');
      root.style.overflow = 'hidden';
      all('body > *').forEach(function (n) { if (n !== drawer && !n.contains(drawer) && n.tagName !== 'SCRIPT') { n.setAttribute('data-ry-inert', ''); n.inert = true; } });
      if (close) close.focus();
    }
    function shut(focusBtn) {
      drawer.classList.remove('is-open'); drawerOpen = false;
      btn.setAttribute('aria-expanded', 'false');
      root.style.overflow = '';
      all('[data-ry-inert]').forEach(function (n) { n.inert = false; n.removeAttribute('data-ry-inert'); });
      setTimeout(function () { if (!drawerOpen) drawer.hidden = true; }, 650);
      if (focusBtn) btn.focus();
    }
    if (btn) btn.addEventListener('click', open);
    if (close) close.addEventListener('click', function () { shut(true); });
    all('a', drawer).forEach(function (a) { a.addEventListener('click', function () { shut(false); }); });
    document.addEventListener('keydown', function (e) {
      if (!drawerOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); shut(true); return; }
      if (e.key === 'Tab') {
        var f = focusables(); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  function init(scope) {
    initHeader();
    all('[data-ry-split]', scope).forEach(function (el) {
      if (el.__ry) return; el.__ry = 1;
      if (!reduce) splitWords(el, 'ry-w', true).forEach(function (w, i) { w.style.setProperty('--i', i); });
      el.classList.add('is-split');
      watch(el);
    });
    all('[data-ry-reveal]', scope).forEach(function (el) { if (el.__ry) return; el.__ry = 1; watch(el); });
    all('[data-ry-count]', scope).forEach(function (el) {
      if (el.__ry) return; el.__ry = 1;
      if (io) { el.textContent = '0'; io.observe(el); }
    });
    all('[data-ry-mani]', scope).forEach(function (el) {
      if (el.__ry) return; el.__ry = 1;
      if (reduce) return;
      manis.push({ el: el, words: splitWords(el, 'ry-mw', true), lit: 0 });
    });
    all('[data-ry-hero]', scope).forEach(function (el) {
      if (el.__ry) return; el.__ry = 1;
      heroes.push({ el: el, content: el.querySelector('.ry-hero__inner'), glow: el.querySelector('.ry-hero__glow-wrap'), bg: el.querySelector('.ry-hero__bg') });
    });
    all('[data-ry-marquee]', scope).forEach(function (el) {
      if (el.__ry) return; el.__ry = 1;
      if (reduce) return;
      var track = el.querySelector('.ry-mq__track'), group = el.querySelector('.ry-mq__group');
      if (!track || !group) return;
      el.classList.add('is-js');
      var q = { el: el, track: track, group: group, x: 0, v: 0, boost: 0, dir: 1, hover: false, base: parseFloat(el.getAttribute('data-speed')) || 70 };
      el.addEventListener('mouseenter', function () { q.hover = true; });
      el.addEventListener('mouseleave', function () { q.hover = false; });
      el.addEventListener('focusin', function () { q.hover = true; });
      el.addEventListener('focusout', function () { q.hover = false; });
      marquees.push(q);
    });
    all('[data-ry-tabs]', scope).forEach(function (sec) {
      if (sec.__ry) return; sec.__ry = 1;
      var tabs = all('[role="tab"]', sec), panels = all('[role="tabpanel"]', sec);
      panels.forEach(function (p) { p.tabIndex = 0; });
      function select(i, focus) {
        tabs.forEach(function (t, j) {
          var on = i === j;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var p = panels[j];
          if (!p) return;
          p.hidden = !on;
          if (on && !reduce) { p.classList.remove('is-show'); void p.offsetWidth; p.classList.add('is-show'); }
        });
        if (focus) tabs[i].focus();
      }
      sec.__select = select;
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          var n = tabs.length, k = e.key;
          if (k === 'ArrowRight' || k === 'ArrowDown') { e.preventDefault(); select((i + 1) % n, true); }
          else if (k === 'ArrowLeft' || k === 'ArrowUp') { e.preventDefault(); select((i - 1 + n) % n, true); }
          else if (k === 'Home') { e.preventDefault(); select(0, true); }
          else if (k === 'End') { e.preventDefault(); select(n - 1, true); }
        });
      });
    });
    /* Legend items are hover-only decoration, not controls */
    all('.ry-key[tabindex]', scope).forEach(function (k) { k.removeAttribute('tabindex'); });
    /* Link email errors to the email field */
    var em = document.getElementById('ry-launch-email'), live = document.querySelector('[data-ry-su-live]');
    if (em && live && !live.id) {
      live.id = 'ry-launch-error';
      var d = (em.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
      if (d.indexOf('ry-launch-error') < 0) d.push('ry-launch-error');
      em.setAttribute('aria-describedby', d.join(' '));
    }
    if (fine && !reduce) {
      all('[data-ry-peek]', scope).forEach(function (list) {
        if (list.__ry) return; list.__ry = 1;
        var rows = all('[data-img]', list).filter(function (r) { return r.getAttribute('data-img'); });
        if (!rows.length) return;
        var peek = document.createElement('div'); peek.className = 'ry-peek'; peek.setAttribute('aria-hidden', 'true');
        var inner = document.createElement('div'); inner.className = 'ry-peek__in';
        var img = document.createElement('img'); img.alt = ''; img.decoding = 'async';
        inner.appendChild(img); peek.appendChild(inner); document.body.appendChild(peek);
        var x = 0, y = 0, tx = 0, ty = 0, running = false;
        function loop() { x += (tx - x) * 0.16; y += (ty - y) * 0.16; peek.style.setProperty('--x', x + 'px'); peek.style.setProperty('--y', y + 'px'); if (peek.classList.contains('is-on') || Math.abs(tx - x) > 0.5) requestAnimationFrame(loop); else running = false; }
        rows.forEach(function (row) {
          row.addEventListener('mouseenter', function (e) { img.src = row.getAttribute('data-img'); tx = x = e.clientX; ty = y = e.clientY; peek.classList.add('is-on'); if (!running) { running = true; requestAnimationFrame(loop); } });
          row.addEventListener('mouseleave', function () { peek.classList.remove('is-on'); });
          row.addEventListener('mousemove', function (e) { tx = e.clientX; ty = e.clientY; });
        });
      });
    }
  }

  var lastY = window.scrollY, lastT = 0;
  function frame(now) {
    var y = window.scrollY, dy = y - lastY, dt = lastT ? Math.min(64, now - lastT) / 1000 : 0.016;
    lastY = y; lastT = now;
    var vh = window.innerHeight;
    if (hdr && hdr.isConnected) {
      hdr.classList.toggle('is-scrolled', y > 30);
      var focusInHdr = hdr.contains(document.activeElement);
      if (!drawerOpen && !focusInHdr) {
        if (y > 420 && dy > 3) hdr.classList.add('is-hidden');
        else if (dy < -3 || y < 420) hdr.classList.remove('is-hidden');
      } else { hdr.classList.remove('is-hidden'); }
    }
    if (!reduce) {
      heroes.forEach(function (h) {
        if (!h.el.isConnected) return;
        var r = h.el.getBoundingClientRect();
        if (r.bottom < 0) return;
        var p = Math.min(1, Math.max(0, -r.top / r.height));
        if (h.content) { h.content.style.transform = 'translate3d(0,' + (-p * 80).toFixed(1) + 'px,0)'; h.content.style.opacity = (1 - p * 0.9).toFixed(3); }
        if (h.glow) h.glow.style.transform = 'translate3d(0,' + (p * 180).toFixed(1) + 'px,0) scale(' + (1 + p * 0.25).toFixed(3) + ')';
        if (h.bg) h.bg.style.transform = 'translate3d(0,' + (p * 120).toFixed(1) + 'px,0) scale(' + (1 + p * 0.08).toFixed(3) + ')';
      });
      manis.forEach(function (m) {
        if (!m.el.isConnected) return;
        var r = m.el.getBoundingClientRect();
        var p = (vh * 0.82 - r.top) / (r.height + vh * 0.3);
        p = Math.min(1, Math.max(0, p));
        var n = Math.round(p * m.words.length);
        if (n === m.lit) return;
        var a = Math.min(n, m.lit), b = Math.max(n, m.lit);
        for (var i = a; i < b; i++) m.words[i].classList.toggle('is-lit', i < n);
        m.lit = n;
      });
      marquees.forEach(function (q) {
        if (!q.el.isConnected) return;
        var w = q.group.offsetWidth;
        if (!w) return;
        if (!paused && dy !== 0) { q.dir = dy > 0 ? 1 : -1; q.boost = Math.min(7, q.boost + Math.abs(dy) * 0.035); }
        q.boost *= 0.93;
        var target = (q.hover || paused) ? 0 : q.base * (1 + q.boost) * q.dir;
        q.v += (target - q.v) * (paused ? 1 : 0.08);
        q.x -= q.v * dt;
        if (q.x <= -w) q.x += w;
        if (q.x > 0) q.x -= w;
        q.track.style.transform = 'translate3d(' + q.x.toFixed(2) + 'px,0,0)';
      });
    }
    requestAnimationFrame(frame);
  }

  function start() {
    init(document);
    requestAnimationFrame(frame);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var sec = e.target.closest('[data-ry-tabs]');
      if (sec && sec.__select) { var tabs = all('[role="tab"]', sec); var i = tabs.indexOf(e.target); if (i > -1) sec.__select(i); }
    });
  }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
})();